import { assetsListBySymbol } from 'abis/set/asset-icons'
import Big from 'big.js'
import { Divider, FlexColumn } from 'components/base'
import { GLOBAL_COLORS } from 'theme'
import { valueToCurrencyFormat } from 'utils'
import {
  AssetIcon,
  AssetWrapper,
  BoldAmount,
  CurrencyValue,
  CurrencyValueContainer,
  MaxButton,
  SectionTitle,
} from '../../../styles'
import { Input, InputBox } from './styled'
import { InputAssetType } from 'components/widgets/invest-component/storage/interface'

interface InputProps {
  receivedSymbol: string
  inputAmount: string
  input: InputAssetType
  onInputChange: (amount: string) => void
}

export const InputComponent = ({
  receivedSymbol,
  inputAmount,
  input,
  onInputChange,
}: InputProps) => {
  const symbol = receivedSymbol.toUpperCase()
  const image = assetsListBySymbol[symbol].icon

  return (
    <FlexColumn>
      <SectionTitle>You pay</SectionTitle>
      <InputBox>
        <AssetWrapper>
          <AssetIcon src={image} />
          <BoldAmount>{symbol}</BoldAmount>
        </AssetWrapper>
        <FlexColumn>
          <Input
            type="text"
            value={inputAmount}
            onChange={({ target }) => onInputChange(target.value)}
            autoComplete="off"
            autoCorrect="off"
            inputMode="decimal"
            pattern={`^[0-9]*[.,]?[0-9]{0,${input.asset.decimals}}$`}
            placeholder="0.00"
            minLength={1}
            maxLength={100}
            spellCheck="false"
          />
          <CurrencyValueContainer>
            <CurrencyValue>
              {valueToCurrencyFormat(input.value ?? Big(0)) ?? 'loading'}
            </CurrencyValue>
            <MaxButton onClick={() => onInputChange(input.adjustedAmount.toString())}>
              Max
            </MaxButton>
          </CurrencyValueContainer>
        </FlexColumn>
      </InputBox>
      <Divider size={1} color={GLOBAL_COLORS.footerBorder} />
    </FlexColumn>
  )
}
